import { RouteConfig } from 'vue-router';

import { Storage } from '@/enums/storage.enum';
import store from '@/store/store';
import { isInvitationTypeValid } from '@/utils/accept';
import Accept from '@/views/Accept.vue';
import { InvitationTypes } from '../enums/invitationTypes.enum';

export const acceptRoute: RouteConfig = {
  path: '/accept/:type/:token',
  name: 'accept',
  component: Accept,
  beforeEnter: (to: any, from: any, next: any) => {
    if (isInvitationTypeValid(to.params.type)) {
      if (!localStorage.getItem(Storage.TOKEN)) {
        next({
          name: 'register',
          params: { type: to.params.type, token: to.params.token }
        });
      } else {
        store
          .dispatch('accept/getMessage', { token: to.params.token, invitationType: to.params.type as InvitationTypes })
          .then(() => next());
      }
    } else {
      next({
        path: '/login'
      });
    }
  }
};
